
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M474.23 12.42c-55.17 11.88-96.74 63.22-96.74 119.73 0 36.4 19.16 74.14 49.04 96.74l12.26 9.2v139.08h-68.01c-74.9 0-96.93 1.72-128.54 9.58C114.27 418.93 23.09 525.83 11.21 658.01-3.54 822.18 118.49 970.46 283.24 988.08c27.2 2.87 406.51 2.87 433.71 0 110.73-11.88 208.43-85.25 250-187.74 70.69-173.95-27.39-368-209-413.6-31.61-7.85-53.64-9.58-128.54-9.58H561.4V238.08l12.26-9.2c30.08-22.61 49.04-60.34 49.04-96.93 0-5.36-1.34-16.47-3.06-24.52-13.61-66.46-78.75-108.99-145.41-95.01zm240.99 490.23c38.12 6.71 70.12 23.37 98.27 51.53 28.16 28.16 44.83 60.15 51.53 98.28 5.56 31.61 2.49 63.98-8.62 95.02-17.43 48.08-60.53 91.19-108.62 108.62-32.37 11.69-29.5 11.49-247.7 11.49s-215.32.19-247.7-11.49c-48.08-17.43-91.19-60.53-108.62-108.62-38.51-106.51 25.1-220.3 136.01-244.06 15.13-3.06 31.03-3.45 217.62-3.45 170.51-.2 204.04.19 217.83 2.68z"}}),_c('path',{attrs:{"d":"M301.63 624.1c-9.19 2.3-25.48 11.88-30.65 18.01-10.73 12.64-14.94 24.33-14.94 40.61-.19 13.6.57 16.86 6.13 28.16 10.54 21.65 29.31 32.95 54.02 33.14 11.49 0 16.48-.96 25.1-4.98 22.41-10.54 35.25-30.65 35.25-55.36-.19-24.52-11.69-43.49-32.57-53.83-13.03-6.32-30.66-8.81-42.34-5.75zm367.81 0c-9.2 2.3-25.48 11.88-30.65 18.01-10.73 12.64-14.94 24.33-14.94 40.61-.19 13.6.58 16.86 6.13 28.16 10.54 21.65 29.31 32.95 54.02 33.14 11.49 0 16.47-.96 25.09-4.98 22.41-10.54 35.25-30.65 35.25-55.36-.19-24.52-11.69-43.49-32.57-53.83-13.02-6.32-30.65-8.81-42.33-5.75z"}})])
          )
        }
      }
    